import { useEffectiveExperience } from '@/features/experiences/contexts/PageExperienceContext';
import {
  LabelDataContext,
  type LabelData,
} from '@/pages/Schedule/components/LabelSelect/LabelDataContext';
import { LabelType } from '@/types/gql.generated';
import { useCreateLabel } from '../hooks/useCreateLabel';
import { useDeleteLabel } from '../hooks/useDeleteLabel';
import { useUpdateLabel } from '../hooks/useUpdateLabel';
import { useUpdateLabelSortOrder } from '../hooks/useUpdateLabelSortOrder';

type Props = {
  labelType: LabelType;
  children: React.ReactNode;
};

export const LabelProvider = ({ labelType, children }: Props) => {
  const experience = useEffectiveExperience();

  const experienceLabels =
    labelType === LabelType.Default ? experience.labels : experience.whoLabels;

  const { createLabel, isPending } = useCreateLabel(labelType);
  const { updateLabel } = useUpdateLabel(labelType);
  const { removeLabel } = useDeleteLabel(labelType);
  const { updateSortOrder } = useUpdateLabelSortOrder(labelType);

  const value: LabelData = {
    labelType,
    labels: experienceLabels,
    createLabel,
    isCreatePending: isPending,
    updateLabel,
    removeLabel,
    updateSortOrder,
  };

  return (
    <LabelDataContext.Provider value={value}>
      {children}
    </LabelDataContext.Provider>
  );
};
